module.exports = __webpack_public_path__ + "assets/videos/covid-hits-home-video-intro.mp4?v=830f0206";